export default {
    props: {
        integration: Object,
    },

    methods: {
        integrationRoute(name, isAjax = false) {
            let prefix = isAjax ? 'ajax.' : '';

            return this.$route(`${prefix}integrations.${this.integration.code}.${name}`);
        }
    }
};
